<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar color="green" dark>
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid">
                            <v-text-field prepend-icon="mdi-email" name="email" label="Email" type="email"
                                          v-model="email" :rules="emailRules" required data-cy="signInEmailField">
                            </v-text-field>
                            <v-text-field prepend-icon="mdi-lock" name="password" label="Password" type="password"
                                          v-model="password" :rules="passwordRules" required data-cy="signInPasswordField">
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text :to="{name: 'SignInReset'}">Password rücksetzen</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1 white--text" :disabled="!valid" @click="onSignIn" data-cy="signInSubmitBtn">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'SignIn',
        data: () => ({
            valid: false,
            email: '',
            password: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v => v.length >= 6 || 'Password must be greater than 6 characters'
            ]
        }),
        methods: {
            onSignIn() {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('signIn', {
                        email: this.email,
                        password: this.password
                    });
                }
            }
        },
        created() {
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type === 'AUTH_ERROR') {
                    let err = this.$store.getters.authError

                    if (err) {
                        this.$toast(err.message, {
                            color: 'red',
                            timeout: 6000,
                            dismissable: true,
                            queueable: true,
                        })
                    }
                }
            });
        },
        beforeDestroy() {
            this.unsubscribe();
        }
    };
</script>

<style scoped>

</style>
